/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Search } from '@coursera/cds-core';

const styles = {
  search: css`
    padding: var(--cds-spacing-100);

    .cds-Search-inputRoot {
      height: 38px;
    }
  `,
};

type Props = {
  onSearch: (searchTerm: string) => void;
  //   onChange: (searchTerm: string) => void;
  onClose: () => void;
};

const ChatSearch = (props: Props): React.ReactElement => {
  const { onSearch, onClose } = props;
  const [searchTerm, setSearchTerm] = React.useState('');

  const handleSearch = (term: string) => {
    setSearchTerm(term);
    onSearch(term);
  };

  //   const handleChange = (term: string) => {
  //     setSearchTerm(term);
  //     onChange(term);
  //   };

  const handleClose = () => {
    setSearchTerm('');
    onClose();
  };

  return (
    <div className="coach-find-in-chat-search">
      <Search
        autoFocus
        onChange={setSearchTerm}
        value={searchTerm}
        placeholder="Search in chat"
        onSearch={handleSearch}
        onClear={handleClose}
        css={styles.search}
        fullWidth
      />
    </div>
  );
};

export default ChatSearch;
